import { defineMessages } from 'react-intl-next';

export default defineMessages({
	removeFileLabel: {
		id: 'ai-mate.chat-input.remove-file-label',
		defaultMessage: 'Remove file {fileName}',
		description:
			'Accessible name for the remove file button. Includes file name so screen reader users can identify which file will be removed when multiple files are attached.',
	},
	fileErrorIconLabel: {
		id: 'ai-mate.chat-input.file-error-icon-label',
		defaultMessage: 'Error loading file',
		description: 'Label for the error icon',
	},
	textLoadFailed: {
		id: 'ai-mate.chat-input.text-load-failed',
		defaultMessage: 'Failed to load file content',
		description: 'Fallback message shown when reading a text file fails',
	},
	textFileTooLarge: {
		id: 'ai-mate.chat-input.text-file-too-large',
		defaultMessage: 'This file is too large to preview ({sizeMB}MB).',
		description:
			'Message shown when text file exceeds the maximum preview size. {sizeMB} is the file size in megabytes.',
	},
} as const);

